import VueSingleSelect from "vue-single-select";

import { VMoney } from 'v-money'
import { axiosRequest } from '../../utils/Requests.js';
import { getReais, getCentavos, getNumeroSemFormatacao } from '../../utils/Utils.js';
import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  components: { 
    VueSingleSelect,
    LMap,
    LTileLayer,
    LMarker
  },
  directives: { money: VMoney },
  props: [ 'id', 'imobiliaria'],
  data() {
    return {
      tabAtiva: 'alugar',
      cidadeBairro: undefined,
      keyValorMinimo: 0,
      keyValorMaximo: 0,
      valorMinimo: undefined,
      valorMaximo: undefined,

      params: {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: undefined,
        quartos: undefined,
        area: undefined
      },

      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },

      loadingImovel: true,
      imovel: {
        tipo: {}
      },

      urlMapaEstatico: null,
      urlPlace: null,
      
      isImagensFullScreen: false,

      urlMapa: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionMapa: '&copy; <a href="http:osm.org/copyright">OpenStreetMap</a> contributors',
      center: latLng(-5.0673272, -42.8014819),
      zoom: 14,
      icon: icon({
        iconUrl: require("../../../assets/imagens/mapIconRed.png"),
        iconSize: [32,37],
        iconAnchor: [16,37]
      }),
    }
  },
  computed: {
    tituloBreadcrumb() { 
      if (!this.imovel || !this.imovel.tituloSite) return "";
      return "#" + this.imovel.idNaImobiliaria + " - " + this.tituloPrincipal; 
    },
    
    tituloPrincipal() { 
      if (!this.imovel) return "";

      const tipo = this.imovel.tipo && this.imovel.tipo.nome ? this.formatarTitulo(this.imovel.tipo.nome) : "Imóvel";
      const operacao = this.imovel.operacao === "ALUGUEL" ? "Alugar" : "Comprar";
      
      let tituloOriginal = this.imovel.tituloSite ? this.formatarTitulo(this.imovel.tituloSite) : "";
      const tituloMinusculo = tituloOriginal.toLowerCase();

      if (tituloMinusculo.includes("para alugar") || tituloMinusculo.includes("para comprar") || tituloMinusculo.includes("venda")) {
        return tituloOriginal;
      }

      let localDestaque = "";
      if (this.imovel.condominio) {
        localDestaque = this.formatarTitulo(this.imovel.condominio);
      } else if (this.imovel.bairro) {
        localDestaque = this.formatarTitulo(this.imovel.bairro);
      } else if (this.imovel.cidade) {
        localDestaque = this.formatarTitulo(this.imovel.cidade);
      }

      if (tituloOriginal.includes(',') || tituloOriginal === '') {
        return `${tipo} para ${operacao} - ${localDestaque}`;
      }

      return `${tituloOriginal}`;
    },
    
    somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
    somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
    ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

    listaCidadesBairros() {
      let array = this.imobiliaria.cidades.map((cidade) => { return { nome: cidade.nome, id: cidade.id } })
      array = array.concat(this.imobiliaria.bairros.map((bairro) => { return { nome: bairro.nome + ' (' + bairro.cidade.nome + ')', id: bairro.cidade.id + "-" + bairro.id } }))
      return array
    },
    numeroWhatsApp() {
      if(this.imovel.operacao == "ALUGUEL") {
        if(this.imobiliaria.whatsappAluguel) { return this.imobiliaria.whatsappAluguel; }
        if(this.imobiliaria.whatsappVenda) { return this.imobiliaria.whatsappVenda; }
      } 
      
      if(this.imovel.operacao == "VENDA") {
        if(this.imobiliaria.whatsappVenda) { return this.imobiliaria.whatsappVenda; }
        if(this.imobiliaria.whatsappAluguel) { return this.imobiliaria.whatsappAluguel; }
      }

      return undefined;
    },
    numeroWhatsAppSemFormatacao() {
      if(this.imovel.operacao == "ALUGUEL") {
        if(this.imobiliaria.whatsappAluguelSemFormatacao) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        if(this.imobiliaria.whatsappVendaSemFormatacao) { return this.imobiliaria.whatsappVendaSemFormatacao; }
      } 
      
      if(this.imovel.operacao == "VENDA") {
        if(this.imobiliaria.whatsappVendaSemFormatacao) { return this.imobiliaria.whatsappVendaSemFormatacao; }
        if(this.imobiliaria.whatsappAluguelSemFormatacao) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
      }
    },

    constructWhatsAppLink() {
      const mensagem = encodeURIComponent(`Olá, tenho interesse no imóvel ${this.imovel.tituloSite} (cod. ${this.imovel.idNaImobiliaria}).`);
      const link = `https://wa.me/55${this.numeroWhatsAppSemFormatacao}?text=${mensagem}`;
      return link;
    },

    googleMapsRouteUrl() {
      if (this.imovel.latitude && this.imovel.longitude && this.imovel.latitude !== 0) {
        return `https://www.google.com/maps/dir/?api=1&destination=${this.imovel.latitude},${this.imovel.longitude}`;
      }

      const partesEndereco = [];
      if (this.imovel.endereco) partesEndereco.push(this.imovel.endereco);
      if (this.imovel.numero) partesEndereco.push(this.imovel.numero);
      if (this.imovel.bairro) partesEndereco.push(this.imovel.bairro);
      if (this.imovel.cidade) partesEndereco.push(this.imovel.cidade);

      if (partesEndereco.length > 0) {
        const enderecoCompleto = partesEndereco.join(', ');
        return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(enderecoCompleto)}`;
      }

      if (this.imovel.urlPlace) {
        return this.imovel.urlPlace;
      }

      return '#';
    },

    urlVideo() {
      if(!this.imovel.urlVideo) {
        return '';
      }

      const urlBase = 'http://www.youtube.com/embed/';
      const urlVideo = this.imovel.urlVideo;

      const pattern1regEx = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=.+$/;
      const pattern2regEx = /^(https?:\/\/)?(www\.)?youtu\.be\/.+$/;

      if(pattern1regEx.test(urlVideo)) {
        const params = urlVideo.split('watch?v=')[1];
        const idVideo = params.split('&')[0];
        return `${urlBase}${idVideo}`;
      }

      if(pattern2regEx.test(urlVideo)) {
        const params = urlVideo.split('youtu.be/')[1];
        const idVideo = params.split('&')[0];
        return `${urlBase}${idVideo}`;
      }

      return '';
    },

    isMapaVisible() {
      return this.urlMapaEstatico != null;
    },

    centroMapa() { 
      if(this.imovel.latitude || this.imovel.longitude) {
        return latLng(this.imovel.latitude, this.imovel.longitude); 
      } else {
        return latLng(-5.0660888, -42.8042637);
      }
    },

    markerIsNotVisible() {
      return this.imovel.latitude !== 0 && this.imovel.longitude !== 0;
    }
  },
  watch: {
    'valorMinimo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMinimo = undefined
        this.params.valorMinimo = undefined
        this.keyValorMinimo++
        this.$nextTick(() => this.$refs.valorMinimoInput.focus())
      } else {
        this.params.valorMinimo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    'valorMaximo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMaximo = undefined
        this.params.valorMaximo = undefined
        this.keyValorMaximo++
        this.$nextTick(() => this.$refs.valorMaximoInput.focus())
      } else {
        this.params.valorMaximo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    cidadeBairro() {
      if(!this.cidadeBairro) {
        this.params.cidade = undefined
        this.params.bairro = undefined
        return
      }

      let array = this.cidadeBairro.id.toString().split("-")
      this.params.cidade = (array[0] ? array[0] : undefined)
      this.params.bairro = (array[1] ? array[1] : undefined)
    },
    imovel() {
      let titulo = this.imovel.tipo.nome + " para " + (this.imovel.operacao == "ALUGUEL" ? "alugar" : "vender") 
      titulo += " - " + this.imovel.bairro + ", " + this.imovel.cidade
      titulo +=   " | " + this.imobiliaria.nome
      
      document.title = titulo;
    }
  },
  created() {
    axiosRequest.get('/imovel/' + this.$route.params.id)
    .then((resultado) => {
        if(resultado.data.item.id !== 0) {
          this.setData(resultado.data.item)
          this.setUrlMapaEstatico(resultado.data.item.urlMapaEstatico);
          this.setUrlPlace(resultado.data.item.urlPlace);
        } else {
          this.$router.replace('/404');
        }
    }).catch((erro) => {
          console.log(erro)
      }).finally(() => {
      this.loadingImovel = false;
    });
  },
  mounted() {
    this.tabAtiva = (this.somenteVenda ? "comprar" : "alugar")
    this.params.operacao = (this.somenteVenda ? "COMPRA" : "ALUGUEL");
  },
  methods: {
    getReais,
    getCentavos,

    setData(imovel) {
        this.imovel = imovel;
        this.loadingImovel = false;
    },

    getTotalEstimado() {
      if(this.imovel.valorAConsultar || !this.imovel.valor || this.imovel.valor === 0) return "A Consultar";
      
      let total = this.imovel.valor || 0;
      
      if(this.imobiliaria.parametros.exibirCondominio && this.imovel.valorCondominio > 0) {
        total += this.imovel.valorCondominio;
      }
      
      if(this.imobiliaria.parametros.exibirIPTU && this.imovel.valorIPTU > 0) {
        total += this.imovel.valorIPTU;
      }
      
      return this.getReais(total);
    },

    formatarNomeProprio(texto) {
      if (!texto) return '';
      
      return texto.toLowerCase().split(' ').map(palavra => {
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
      }).join(' ');
    },

    formatarTitulo(texto) {
      if (!texto) return '';

      const excecoes = ['de', 'do', 'da', 'dos', 'das', 'no', 'na', 'nos', 'nas', 'em', 'com', 'para', 'e', 'o', 'a', 'os', 'as', 'um', 'uma'];

      return texto.toLowerCase().split(' ').map((palavra, index) => {
        if (excecoes.includes(palavra) && index !== 0) {
          return palavra;
        }
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
      }).join(' ');
    },

    formatarDescricaoTexto(texto) {
      if (!texto) return '';

      let formatado = texto.toLowerCase();
      formatado = formatado.charAt(0).toUpperCase() + formatado.slice(1);

      formatado = formatado.replace(/([.?!])\s*(.)/g, function(match, pontuacao, letra) {
          return pontuacao + ' ' + letra.toUpperCase();
      });

      formatado = formatado.replace(/caracter[íi]sticas do condom[íi]nio:/i, '\n\nCaracterísticas do condomínio:');

      return formatado;
    },

    async compartilharImovel() {
      const textoCompartilhamento = `Confira este imóvel: ${this.tituloPrincipal} (Cód: ${this.imovel.idNaImobiliaria})`;
      const urlAtual = window.location.href;

      const dadosParaCompartilhar = {
        title: this.tituloPrincipal,
        text: textoCompartilhamento,
        url: urlAtual
      };

      if (navigator.share) {
        try {
          await navigator.share(dadosParaCompartilhar);
        } catch (erro) {
          console.log('Compartilhamento cancelado pelo usuário.', erro);
        }
      } else {
        try {
          await navigator.clipboard.writeText(`${textoCompartilhamento} \n${urlAtual}`);
          
          this.$bvToast.toast('Link do imóvel copiado para a área de transferência!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 4000
          });
        } catch (erro) {
          console.error('Falha ao copiar o link', erro);
        }
      }
    },

    setUrlMapaEstatico(url) {
      this.urlMapaEstatico = url;
    },
    setUrlPlace(url) {
      this.urlPlace = url;
    },

    pesquisar() {
      this.params.operacao = (this.tabAtiva == "alugar" ? "ALUGUEL" : "VENDA")
      this.pagina = 0;

      this.$router.push(this.montarURL())
    },
    montarURL() {
      return {
        path: this.montarParametroURL(),
        query: { 
          pagina: this.pagina,
          valorMinimo: (this.params.valorMinimo ? this.params.valorMinimo : undefined),
          valorMaximo: (this.params.valorMaximo ? this.params.valorMaximo : undefined),
          quartos: (this.params.quartos ? this.params.quartos : undefined),
          area: (this.params.area ? this.params.area : undefined)
        }
      }
    },
    montarParametroURL() {
      var texto = "/imoveis/" + this.tabAtiva

      let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.id == this.params.tipoImovel })[0];
      if(tipo) { texto += "/" + tipo.key }

      let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.id == this.params.cidade })[0];
      if(cidade) { texto += "/" + cidade.key }

      let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.id == this.params.bairro })[0];
      if(bairro) { texto += "/" + bairro.key }

      return texto;
    }
  }
}